// Considered: SegmentedControlAtom — not rejected; ScopeSegmentAtom is a named preset of it
// (Only this / + Sub-spheres, pills, single-select). Extracted to its own file because it
// has two consumers: the per-row toggle and the dialog add-time scope bar. Co-locating in
// either would force a cross-boundary import. See spec Reuse Audit.
import React, { useMemo } from 'react';
import { useTranslation } from 'localization';
import { SegmentedControlAtom } from '../SegmentedControl';
import type { ScopeMode } from 'types/channel';
import './ScopeSegmentAtom.scss';

export interface ScopeSegmentAtomProps {
  value: ScopeMode;
  onChange: (value: ScopeMode) => void;
  size?: 'small' | 'normal';
  ariaLabel?: string;
  className?: string;
}

const ScopeSegmentAtom: React.FC<ScopeSegmentAtomProps> = ({
  value,
  onChange,
  size = 'small',
  ariaLabel,
  className = '',
}) => {
  const { t } = useTranslation();

  const scopeOptions = useMemo(
    () => [
      {
        value: 'direct' as ScopeMode,
        label: t('sphereChannels.subscriptionsPanel.scopeSegment.onlyThis'),
        icon: 'pi pi-circle-on',
      },
      {
        value: 'recursive' as ScopeMode,
        label: t('sphereChannels.subscriptionsPanel.scopeSegment.subSpheres'),
        icon: 'pi pi-share-alt',
      },
    ],
    [t]
  );

  return (
    <SegmentedControlAtom
      options={scopeOptions}
      value={value}
      onChange={(v) => onChange(v as ScopeMode)}
      mode="single"
      variant="pills"
      size={size}
      ariaLabel={ariaLabel ?? t('sphereChannels.subscriptionsPanel.scopeSegment.ariaLabel')}
      className={['scope-segment-atom', className].filter(Boolean).join(' ')}
    />
  );
};

ScopeSegmentAtom.displayName = 'ScopeSegmentAtom';

export default ScopeSegmentAtom;
